import { render, staticRenderFns } from "./FileSelect.vue?vue&type=template&id=4187396a&"
import script from "./FileSelect.vue?vue&type=script&lang=ts&"
export * from "./FileSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports